module.exports = __webpack_public_path__ + "img/bw.55f1a01b.svg";